import { MdOutlinePhoneIphone } from "react-icons/md";
import { GoMail } from "react-icons/go";

export const UserData = [
  {
    id: 0,
    name: "Carl Driffith",
    age: 21,
    gender: "male",
    phone: <MdOutlinePhoneIphone />,
    email: <GoMail />,
    address: "",
    status: "W",
  },
  {
    id: 1,
    name: "Evelyn Leger",
    age: 32,
    gender: "male",
    phone: <MdOutlinePhoneIphone />,
    email: <GoMail />,
    address: "",
    status: "Sent",
  },
  {
    id: 2,
    name: "Michael Hoover",
    age: 46,
    gender: "male",
    phone: "",
    email: <GoMail />,
    address: "",
    status: "Expired",
  },
  {
    id: 3,
    name: "Coal Diffith",
    age: 45,
    gender: "male",
    phone: <MdOutlinePhoneIphone />,
    email: "",
    address: "",
    status: "Completed",
  },
  {
    id: 4,
    name: "Jayasriraam",
    age: 21,
    gender: "male",
    phone: <MdOutlinePhoneIphone />,
    email: <GoMail />,
    address: "",
    status: "Completed",
  },
  {
    id: 5,
    name: "Coal Diffith ",
    age: 45,
    gender: "male",
    phone: "",
    email: <GoMail />,
    address: "",
    status: "Completed",
  },
];

export const Editdata = [
  {
    name: "Dave S George",
    age: 35,
    gender: "male",
    birthday: "jan 06 2003",
    phone: 1234567890,
    ssn: 78051120,
    Relationship: "Dependant",
    address: "132, My Street, Apartment 1001 Kingston, New York 12401",
    insurancecarriername: "Delta Dental California",
    subscriberID: "114983100201",
    patient: "114983100201",
    group: "114983100201",
    groupnumber: "00362-00001",
    PatientsRelationship: "Child",

    Eligibility: "Eligible",
    Networkparticipation: "Out of Network",
    Policynetworktype: "PPO",
    Policyeffectivedate: "Jun/01/2019",
    BenefitMax: "$2,000.00",
    Renewal: "Lifetime",
    BenefitRemaining: "$500.00",
    CoinsurancePercentage: "50%",
    PreAuth: "None",
    WaitingPeriod: "None",
    AgeRestrictions: "19",
    Deductible: "$2",
    CoordinationofBenefits: "Standard",
    AssignmentofBenefits: "Practice",
    MedicallyNecessaryOnly: "Yes",
  },
];
